var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2216_4658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0988 6.43715L6.02519 2.33599C5.76038 2.17587 5.4463 2.0835 5.10759 2.0835C4.41631 2.0835 3.81716 2.48268 3.52484 3.05891L10.0034 9.53412L13.0988 6.43715Z",
    fill: "#171719"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33466 3.81138C3.33421 3.82654 3.33398 3.8418 3.33398 3.85718V16.1556C3.33398 16.1727 3.33419 16.1896 3.33462 16.2064L9.53216 10.0056L3.33466 3.81138Z",
    fill: "#171719"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53011 16.9539C3.82431 17.5268 4.42044 17.9169 5.10759 17.9169C5.43398 17.9169 5.7419 17.8307 6.00672 17.6706L6.02519 17.6583L13.1038 13.5754L10.0037 10.4769L3.53011 16.9539Z",
    fill: "#171719"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7079 13.2366L16.5808 11.5798C17.135 11.2781 17.5107 10.693 17.5107 10.0217C17.5107 9.35047 17.1412 8.76542 16.5869 8.46981V8.46366H16.5808L13.6951 6.7836L10.475 10.0054L13.7079 13.2366Z",
    fill: "#171719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2216_4658)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#C2C4C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.f9c2ca5a3e581a271a9f6459ba9772be.svg";
export { ForwardRef as ReactComponent };